import React, { useMemo } from 'react';
import { IResortPathInfo } from 'api/resort/types';
import {
  CurrentLink, CurrentTab, linksPlan, linksSnow, onlyLodgingAndSkiRental,
} from 'components/resort/ResortHeaderNav/constants';
import { isMainLocale } from 'util/i18nFlags';
import { useOTSTranslation } from 'i18n/useOTSTranslation';
import { useNoHeader } from 'util/useNoHeader';
import { HeroNav } from 'components/common/HeroNav';
import { IRegionShort, IRelatedForRegion, IRelatedForResort } from 'api/region/types';
import { RESORT_IDS_TO_HIDE_LODGING_FOR } from 'ots-constants';
import { getLocale } from 'i18n/locale';
import { ELocale } from 'i18n/localeEnum';

/**
 * This is both the resort navigation and resort header experience.
 */
export const ResortHeaderNav = ({
  resort, link, liftsUrl, photo, title, isPartner, website, phone, video, region, related, noOffers,
}: {
  resort: IResortPathInfo,
  tab: CurrentTab,
  link: CurrentLink,
  liftsUrl?: string,
  photo: string,
  title: string
  website?: string,
  phone?: string,
  isPartner?: boolean,
  video?: string,
  region?: IRegionShort,
  related?: IRelatedForRegion | IRelatedForResort,
  noOffers?: boolean;
}) => {
  const { t } = useOTSTranslation('common');
  const locale = getLocale() as ELocale;

  const linksSnowPart = useMemo(() => linksSnow(resort, t), [resort, t]);
  const linksPlanningPart = useMemo(
    () => {
      let links = [...(isMainLocale() ? linksPlan(resort, liftsUrl, t) : onlyLodgingAndSkiRental(resort, t))];

      if (noOffers || RESORT_IDS_TO_HIDE_LODGING_FOR.includes(resort.uuid)) {
        links = links.filter((item) => item.uuid !== CurrentLink.LODGING);
      }

      if (locale === ELocale.FR_FR && resort.uuid === '592') {
        links = links.filter((item) => item.uuid !== CurrentLink.BOOK_TRIP);
      }

      return links;
    }, [resort, liftsUrl, t, noOffers, locale],
  );

  const { noHeader } = useNoHeader();
  if (noHeader) {
    return null;
  }

  return (
    <HeroNav
      title={title}
      backgroundPhoto={photo}
      links={[...linksSnowPart, ...linksPlanningPart]}
      link={link}
      isPartner={isPartner}
      phone={phone}
      website={website}
      video={video}
      region={region}
      resort={
        resort
      }
      related={related}
    />
  );
};
